// extracted by mini-css-extract-plugin
module.exports = {"form-input":"AssetsSettings_form-input__82V-z","content":"AssetsSettings_content__1fZFE","title":"AssetsSettings_title__31T2K"};